// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

//  rutaBase: "https://dev.digitalfactoring.net",
//  secret_key: "6oCgtPH8Y0FivMGlhQCkseiqA",
rutaBase:"https://api.starkengine.com",
secret_key: "cd2nRttcAGmIiw4WeK5MUUnbowoabW",

  dias_minimo: 5,
  dias_maximo: 185,
  adelanto_minimo: 25,
  adelanto_maximo: 100,
  adelanto_default: 90,
  tasa_minimo: 0,
  tasa_maximo: 3.0,
  ID_GUIA_SOLES:2,
  ID_GUIA_DOLARES:3,
  LABEL_PROVEEDOR:"Proveedor",
  LABEL_PROVEEDORES:"Proveedores",
  LABEL_ADQUIRENTE:"Adquirente",
  LABEL_ADQUIRENTES:"Adquirentes",
  LABEL_DOCUMENTOS:"Documentos Negociables",
  LABEL_COTIZACIONES:"Cotizaciones",
  LABEL_OPERACIONES:"Operaciones",
  ID_EMPRESA:4
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
